import { call, put, select, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { BASKET_FLOW_UPDATE_ITEM, BasketFlowUpdateItemPayload } from 'features/basket';
import { EffectR } from 'types/utils';
import { NOT_SET } from '../utils';
import { selectProductDiscount, selectProductInfo, selectProductPricePrevious } from './selectors';
import {
  CompareCategory,
  getProductPriceCategory,
  getVariantsModel,
  selectCompareCategory,
  selectProductBrand,
} from '../../product-info';
import { VariantsModel } from '../../variants';

/**
 * Cобытие должно срабатывать при удалении товара из корзины.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaRemoveFromCart = createAction('GA:removeFromCart')<{
  elementType: 'button';
  elementBlock: string; // блок, в котором расположен элемент
  elementName?: 'sticky-menu';

  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productQuantity: string; // на какое количество единиц изменилось количество товара
  productPosition?: string;
  productBelong: 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail'; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productPrevPrice: string | null;
  productTag?: string | null; // название шильда (бейджа) на товаре
  productDiscount: number | null;
  brand?: string | null;
  category?: string;
  is_variable: boolean;
  variant_selected: string | null;
}>();

function* putGaRemoveFromCart(
  productId: string,
  quantity: number,
  context?: BasketFlowUpdateItemPayload['context'],
  isStickyMenu?: boolean,
) {
  const productQuantity = Number.isFinite(quantity) ? Number(quantity).toFixed(2) : NOT_SET;
  const productInfo = (yield selectProductInfo(context)) as EffectR.Call<typeof selectProductInfo>;
  const variantsModelContainer: VariantsModel | null = yield select(getVariantsModel);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};
  const isVariable = Boolean(variantsModel && variantsModel.length > 0);
  const variantSelected = isVariable && activePoint?.displayedName ? activePoint.displayedName : null;
  const productTag = (yield select(getProductPriceCategory)) as EffectR.Select<
    typeof getProductPriceCategory
  >;
  const brand = (yield call(selectProductBrand)) as string;
  const compareCategory = (yield call(selectCompareCategory)) as CompareCategory;

  yield put(
    gaRemoveFromCart({
      ...productInfo,
      elementType: 'button',
      productId,
      productTag,
      productQuantity,
      productPrevPrice: yield call(selectProductPricePrevious),
      productDiscount: yield call(selectProductDiscount),
      brand,
      category: compareCategory?.name || '',
      is_variable: isVariable,
      variant_selected: variantSelected,
      ...(isStickyMenu && { elementName: 'sticky-menu' }),
    }),
  );
}

export function* runRemoveFromCartDetector() {
  yield takeEvery(
    BASKET_FLOW_UPDATE_ITEM,
    function* handle({ payload }: { payload: BasketFlowUpdateItemPayload }) {
      const { productId, flowQty, context, isStickyMenu } = payload;
      if (flowQty < 0) {
        yield putGaRemoveFromCart(productId, Math.abs(flowQty), context, isStickyMenu);
      }
    },
  );
}
